import RootState from '../../rootState';
import { Message } from '../../../models/message';

export class Action {
    type!: string;
    screenName!: string;
    hasDirtyData!: boolean;
    message!: string;
    messageType!: string;
}

export interface State {
    dirtyDatas: {
        [id: string]: boolean;
    };
    messageIndicator?: Message;
}

const baseAction = new Action();

export const types = {
    SET_HAS_DIRTY_DATA: 'App/SET_HAS_DIRTY_DATA',
    SET_MESSAGE_INDICATOR: 'App/SET_MESSAGE_INDICATOR'
};

export const actions = {
    setHasDirtyData: (screenName: string, hasDirtyData: boolean): Action => ({
        ...baseAction,
        type: types.SET_HAS_DIRTY_DATA,
        screenName: screenName,
        hasDirtyData: hasDirtyData
    }),

    setMessageIndicator: (message: string, type: string): Action => ({
        ...baseAction,
        type: types.SET_MESSAGE_INDICATOR,
        message: message,
        messageType: type
    })
};

export namespace selectors {
    export function getState(rootState: RootState): State {
        return rootState.uis.app;
    }

    export function getHasDirtyData(rootState: RootState): boolean {
        const { dirtyDatas } = getState(rootState);
        const hasDirtyDatas = Object.keys(dirtyDatas).map(x => dirtyDatas[x]).filter((hasDirtyData: boolean, index: number) => {
            return hasDirtyData === true;
        });

        if (hasDirtyDatas.length > 0) {
            return true;
        }

        return false;
    }

    export function getDirtyDataOnScreen(rootState: RootState, screenName: string): boolean {
        const { dirtyDatas } = getState(rootState);
        if (dirtyDatas.hasOwnProperty(screenName)) {
            return dirtyDatas[screenName];
        }

        return false;
    }

    export function  getMessageIndicator(rootState: RootState): Message {
        const { messageIndicator } = getState(rootState);
        return messageIndicator ? messageIndicator : new Message();
    }
}


// WEBPACK FOOTER //
// ./src/modules/uis/app/index.ts